import { ORIGIN } from './api.routes';

export function prepareFullImagePath(imagePath: string) {
  return `${ORIGIN}${imagePath}`;
}
